/**
 * @file This file contains the configuration for the "Mini Merge" game mode.
 * @module miniMergeConfig
 */

export const miniMergeConfig = {
    // Game Mode settings
    gameMode: 'mini-merge',
    isMiniMerge: true,
    
    // Grid settings. The playable area is 1x3, but we use a larger grid for layout consistency.
    gridSize: 3,

    // Queue settings
    queueSize: 5,

    // Gameplay settings
    isAnimalsEnabled: false,
    isPowerupsEnabled: false,
    isDisastersEnabled: false,
    isObstaclesEnabled: false,
    isStationaryObjectsEnabled: false,
    isSettlementsEnabled: false,
    
    // Feature toggles
    isWeatherEnabled: true,
    isNpcsEnabled: true,

    // Path length will be selected by the user, but we can set a default
    pathLength: 'default', // Corresponds to "Medium"

    // Other settings
    thinkBuffer: 2,
};